export const FETCH_TARGETS_REQUEST = 'writing/FETCH_TARGETS_REQUEST';
export const FETCH_TARGETS_SUCCESS = 'writing/FETCH_TARGETS_SUCCESS';
export const FETCH_TARGETS_FAILURE = 'writing/FETCH_TARGETS_FAILURE';

export const CREATE_NEWSLETTER_REQUEST = 'writing/CREATE_NEWSLETTER_REQUEST';
export const CREATE_NEWSLETTER_SUCCESS = 'writing/CREATE_NEWSLETTER_SUCCESS';
export const CREATE_NEWSLETTER_FAILURE = 'writing/CREATE_NEWSLETTER_FAILURE';

export const INIT_NEWSLETTER = 'writing/INIT_NEWSLETTER';

export const CLEAR_NEWSLETTER_ERROR = 'writing/CLEAR_NEWSLETTER_ERROR';
export const CLEAR_TARGETS_ERROR = 'writing/CLEAR_TARGETS_ERROR';

export const fetchTargetsRequest = (payload = {}) => ({
  type: FETCH_TARGETS_REQUEST,
  payload,
});
export const fetchTargetsSuccess = (payload = {}) => ({
  type: FETCH_TARGETS_SUCCESS,
  payload,
});
export const fetchTargetsFailure = (payload = {}) => ({
  type: FETCH_TARGETS_FAILURE,
  payload,
});

export const createNewsletterRequest = payload => ({
  type: CREATE_NEWSLETTER_REQUEST,
  payload,
});
export const createNewsletterSuccess = payload => ({
  type: CREATE_NEWSLETTER_SUCCESS,
  payload,
});
export const createNewsletterFailure = payload => ({
  type: CREATE_NEWSLETTER_FAILURE,
  payload,
});

export const initNewsletter = payload => ({
  type: INIT_NEWSLETTER,
  payload,
});

export const clearNewsletterError = () => ({
  type: CLEAR_NEWSLETTER_ERROR,
});

export const clearTargetsError = () => ({
  type: CLEAR_TARGETS_ERROR,
});
